import activity from './activity.json';
import assets from './assets.json';
import auth from './auth.json';
import commissions from './commissions.json';
import common from './common.json';
import dashboard from './dashboard.json';
import payouts from './payouts.json';
import profile from './profile.json';
import referralNetwork from './referralNetwork.json';
import rewards from './rewards.json';
import rewardsV3 from './rewardsV3.json';
import shareLink from './shareLink.json';
import stats from './stats.json';
import transactions from './transactions.json';

const en = {
  activity,
  assets,
  auth,
  commissions,
  common,
  dashboard,
  payouts,
  profile,
  referralNetwork,
  rewards,
  shareLink,
  stats,
  rewardsV3,
  transactions,
};

export default en;
